import React from 'react'
import { Container, Card, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './index.css'

const Home = (props) => {
  const authToken = window.localStorage.getItem('token')

  const loginLink = !authToken && (
    <Card.Footer>
      Are you a Kingsland Student? <Link to="/login">Login</Link>
    </Card.Footer>
  )

  return (
    <Container fluid id="welcome-container">
      <Row id="welcome">
        <Col md={6} id="welcome-content">
          <Card.Body>
            <Card.Title>
              <h1 className="welcome-header gs">
                WELCOME,
                <br />
                KINGSLAND STUDENT!
              </h1>
            </Card.Title>
            <Card.Text>
              <p className="welcome-text fs-4">
                This is the lessons recording replay platform of Kingsland
                University.
              </p>
            </Card.Text>
          </Card.Body>
          {loginLink}
        </Col>
        <div id="waveStyle" />
      </Row>
      <Row id="about">
        <Col id="container" sm={{ span: 8, offset: 2 }}>
          <Row>
            <h1 className="mt-5">ABOUT THE PLATFORM</h1>
            <span className="fs-4 mt-4">
              Kingsland Replay provides you a fast and convenient replay access
              to your lecture recordings.
              <br />
              All lecture recordings will be available on Kingsland Replay
              within 6 hours after the end of each lecture.
            </span>
          </Row>
          <Row>
            <img
              className="background-icon"
              src="/assets/edit-solid.svg"
              alt="Background Icon"
            />
            <h1 className="mt-5">FEATURES</h1>
            <span className="fs-4 mt-4">
              All of our recordings are hosted on edge servers all over the
              world.
              <br />
              Wherever you are, you are guaranteed that access to your
              recordings are fast.
              <br />
              <br />
              Recordings include transcriptions.
              <br />
              If you are looking for a discussed concept but you don't want
              <br />
              to spend time seeking the video to the content you are looking
              for,
              <br />
              Try the transcript search.
            </span>
          </Row>
          <Row>
            <h1 className="mt-5">SUPPORT</h1>
            <span className="fs-4 mt-4">
              If you are having problems on the platform,
              <br />
              please reach out on the <b>#admin-questions</b> channel on your
              cohort's Slack workspace.
              <br />
              <br />
              If you want to see something here which you think would help
              improve the platform,
              <br />
              we are open for feature request suggestions!
              <br />
              Send us an email on:{' '}
              <a id="email-link" href="mailto:dev_ops@kingsland.io">
                dev_ops@kingsland.io
              </a>
            </span>
          </Row>
        </Col>
      </Row>
      <Row id="brand">
        <Col className="d-flex flex-column justify-content-center align-items-center">
          <Row>
            <Col>
              <img
                src="/banner.png"
                alt="Kingsland University"
                className="brand-img m-5"
              />
            </Col>
            <Col>
              <img
                src="/assets/Kingsland_InnovationCentre_Teal_HorizontalwK__2_.png"
                alt="Kingsland Innovation Center"
                className="brand-img m-5"
              />
            </Col>
          </Row>
          <Row id="copyright" className="mb-4">
            {' '}
            &copy; Kingsland University
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default Home
